import { render, staticRenderFns } from "./GroupDetailsPage.vue?vue&type=template&id=73afa190&scoped=true"
import script from "./GroupDetailsPage.vue?vue&type=script&lang=js"
export * from "./GroupDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./GroupDetailsPage.vue?vue&type=style&index=0&id=73afa190&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73afa190",
  null
  
)

export default component.exports